<ion-card [languageRouter]="['promocion', promo.uuid]">
  <span *ngIf="promo?.data">
    <div *ngIf="!promo.partners" class="promo-image-container">
      <img [src]="promo.data.image ? promo.data.image : promo.shop.logo" />
    </div>

    <div class="promo-image-partners-container" *ngIf="promo.partners">
      <div class="content">
        <img [src]="promo.data.image ? promo.data.image : promo.shop.logo" />
        <i class="icon-citycard"></i>
      </div>
    </div>
  </span>

  <ion-card-content>
    <ng-container *ngIf="promo?.shop?.name">
      <ion-note class="label">{{ promo.shop.name }}</ion-note>
    </ng-container>
      <ng-container *ngIf="promo?.shopName && promo?.shopName[language]">
          <ion-note class="label">{{ promo.shopName[language] }}</ion-note>
      </ng-container>
    <ng-container *ngIf="promo.data">
      <h5 *ngIf="promo.data.title" class="promo-title">{{ promo.data.title }}</h5>
    </ng-container>
    <ion-card-subtitle>
      {{"FIELDS.FROM_DATE" |translate}}
      <span *ngIf="!promo?.startDate?.date">{{ (promo.startDate?.split('T')[0]) | date: dateFormat:'shortDate' }}</span>
      <span *ngIf="promo?.startDate?.date">{{ (promo.startDate?.date?.split('T')[0]) | date: dateFormat:'shortDate' }}</span>
      {{"FIELDS.TO_DATE" |translate}}
      <span *ngIf="!promo?.endDate?.date">{{ (promo.endDate?.split('T')[0]) | date: dateFormat:'shortDate' }}</span>
      <span *ngIf="promo?.endDate?.date">{{ (promo.endDate?.date?.split('T')[0]) | date: dateFormat:'shortDate' }}</span>
    </ion-card-subtitle>
  </ion-card-content>
</ion-card>
